<template>
  <div class="content if-profile">
    <div class="md-layout if-profile-body">
      <SPIFProfileHeader  :headerData="this.headerData"/>

      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0 mt-4">
        <div class="navbar md-toolbar md-transparent md-elevation-4 p-0">
          <h1 class="section_header">Financial Ratios</h1>
          <!-- <h1 class="md-subheading profile-title">Financial Ratios</h1> -->
          <!-- <div class="">
              <md-dialog :md-active.sync="showDialog">
                <p>
                  <b
                    >[Earnings before Interest, Income Taxes due,
                    Depreciation-Amortization]/Interest expense.</b
                  >
                  Assesses financial stability by examining whether a company is
                  profitable enough to pay interest expense. A ratio >1.00 is
                  desirable. Your score suggests that the business reflects debt
                  risk on par with industry peers.
                  <br />
                  <br />
                  <b>Current Liabilities/Net Worth.</b> Reflects a level of
                  capability to satisfy short-term debt. The larger the ratio
                  relative to industry norms, the higher the risk and the less
                  security there is for creditors. Your score suggests that the
                  business indicates significantly higher short-term debt risk
                  relative to industry peers. <br /><br />
                  <b>Long-Term Liabilities/Net Worth, </b>a measure of debt
                  coverage. Indicates the business capability to satisfy long
                  term debt. The larger the ratio relative to industry norms,
                  the higher the risk. Your score suggests that the business
                  indicates significantly higher long-term debt risk relative to
                  industry peers. <br /><br />
                  <b>Loans-Notes Payable/Net Worth.</b> The Loans plus notes
                  payable portion of current liabilities, a measure of
                  short-term debt coverage. In general, lower is better. Your
                  score suggests that the business indicates significantly
                  higher overall debt risk relative to industry peers.
                  <br /><br />
                  A modified form of the <b> Altman Z-Score </b>which evaluates
                  default risk. The modified Z-Score substitutes Discretionary
                  Owner Earnings for Net Profit and Net Worth for Retained
                  Earnings to better capture small business operations. In all
                  cases higher (at or above the industry level) is desired.
                  Modified Z-Score calculations for this industry are:
                  ([Operating Income/Total Assets]*6.72) + ([Net Worth/Total
                  Liabilities]*1.05) + ([Working Capital/Total Assets]*6.5) +
                  ([Discretionary Owner Earnings/Total Assets]*3.26) Your score
                  suggests that the business indicates default risk on par with
                  industry peers. <br /><br />
                  <b>Total liabilities/Net Worth.</b>This ratio helps to clarify
                  the total risk impact of debt. Total liability levels should
                  be comfortably less than Net Worth except in special
                  circumstances. The most advantageous ratios are around or
                  somewhat below industry norms, balancing current and long term
                  liability values. Your score suggests that the business
                  indicates significantly higher overall debt risk relative to
                  industry peer group standards.
                </p>
              </md-dialog>
              <md-card-header class="md-card-header-icon messages-box">
                <div class="card-icon md-ripple" @click="showDialog = true">
                  <md-icon class="icon-arrow">double_arrow</md-icon>
                  <md-icon>help</md-icon>
                </div>
              </md-card-header>
            </div> -->
          <div class="md-toolbar-row fundamentals_wpr profit-loss p-0">
            <div class="md-card-nav-tabs">
              <div class="md-toolbar-row fundamentals_area p-0 m-0">
                <nav-tabs-card no-label md-elevation="0">
                  <template slot="content">
                    <md-tabs md-alignment="left" class="p-0">
                      <md-tab
                        md-label="Cash flow-Solvency"
                        md-icon="money"
                        class="p-0"
                      >
                        <div class="md-layout">
                          <div class="md-layout-item md-size-100 p-0">
                            <md-card class="m-0">
                              <md-card-header>Cash flow-Solvency</md-card-header>
                              <md-card-content>
                                <div class="md-layout">
                                  <div class="md-layout-item md-medium-size-100 md-size-100 p-0">
                                    <md-table
                                      v-model="cashflow"
                                      table-header-color="blue"
                                      class="profit-and-loss-table"
                                    >
                                      <md-table-row
                                        slot="md-table-row"
                                        slot-scope="{ item }"
                                      >
                                        <md-table-cell md-label="Parameters" class="md-table-side-label">
                                          {{ item.name }}
                                          <!-- {{ tablesInfo[item.name]['title'] }} -->
                                          <!-- <md-tooltip md-direction="bottom"> -->
                                          <!-- {{ tablesInfo[item.name]['rollover'] }} -->
                                          <!-- </md-tooltip> -->
                                        </md-table-cell>

                                        <md-table-cell md-label="Trend" class="table_chart">
                                          <chart-card
                                            header-animation="false"
                                            :chart-data="colouredLineChart.data"
                                            :chart-options="colouredLineChart.options"
                                            chart-type="Line"
                                            header-icon
                                            chart-inside-content
                                            no-footer
                                            background-color="blue"
                                          >
                                          </chart-card>
                                        </md-table-cell>

                                        <md-table-cell
                                          v-for="key in Object.keys(item.dates)"
                                          :key="key"
                                          :md-label="key"
                                          >{{ item.dates[key] }}%
                                        </md-table-cell>
                                      </md-table-row>
                                    </md-table>
                                  </div>
                                </div>
                              </md-card-content>
                            </md-card>
                          </div>

                          <div
                            v-for="(chart, index) in chartData.cashflow"
                            :key="index"
                            class="md-layout-item md-medium-size-100 md-size-50"
                          >
                            <chart-card
                              header-animation="false"
                              :chart-data="chart.data"
                              :chart-options="options"
                              chart-type="Line"
                              header-icon
                              chart-inside-content
                              no-footer
                              background-color="blue"
                            >
                              <template slot="chartInsideHeader">
                                <div class="card-icon">
                                  <md-icon>timeline</md-icon>
                                </div>
                                <h4 class="title">{{ chart.title }}</h4>
                              </template>
                            </chart-card>
                          </div>
                        </div>
                      </md-tab>
                      <md-tab
                        md-label="Profitability"
                        md-icon="payments"
                        class="p-0"
                      >
                        <div class="md-layout">
                          <div class="md-layout-item md-size-100 p-0">
                            <md-card class="m-0">
                              <md-card-header>Profitability</md-card-header>
                              <md-card-content>
                                <div class="md-layout">
                                  <div class="md-layout-item md-medium-size-100 md-size-100 p-0">
                                    <md-table
                                      v-model="profitability"
                                      table-header-color="blue"
                                      class="profit-and-loss-table"
                                    >
                                      <md-table-row
                                        slot="md-table-row"
                                        slot-scope="{ item }"
                                      >
                                        <md-table-cell md-label="Parameters" class="md-table-side-label">
                                          {{ item.name }}
                                          <!-- {{ tablesInfo[item.name]['title'] }} -->
                                          <!-- <md-tooltip md-direction="bottom" -->
                                          <!-- >{{ tablesInfo[item.name]['rollover'] }} -->
                                          <!-- </md-tooltip> -->
                                        </md-table-cell>

                                        <md-table-cell md-label="Trend" class="table_chart">
                                          <chart-card
                                            header-animation="false"
                                            :chart-data="colouredLineChart.data"
                                            :chart-options="colouredLineChart.options"
                                            chart-type="Line"
                                            header-icon
                                            chart-inside-content
                                            no-footer
                                            background-color="blue"
                                          >
                                          </chart-card>
                                        </md-table-cell>

                                        <md-table-cell
                                          v-for="key in Object.keys(item.dates)"
                                          :key="key"
                                          :md-label="key"
                                          >{{ item.dates[key] }}
                                        </md-table-cell>
                                      </md-table-row>
                                    </md-table>
                                  </div>
                                </div>
                              </md-card-content>
                            </md-card>
                          </div>

                          <div
                            v-for="(chart, index) in chartData.profitability"
                            :key="index"
                            class="md-layout-item md-medium-size-100 md-size-50"
                          >
                            <chart-card
                              header-animation="false"
                              :chart-data="chart.data"
                              :chart-options="options"
                              chart-type="Line"
                              header-icon
                              chart-inside-content
                              no-footer
                              background-color="blue"
                            >
                              <template slot="chartInsideHeader">
                                <div class="card-icon">
                                  <md-icon>timeline</md-icon>
                                </div>
                                <h4 class="title">{{ chart.title }}</h4>
                              </template>
                            </chart-card>
                          </div>
                        </div>
                      </md-tab>
                      <md-tab md-label="Efficiency" md-icon="pie_chart" class="p-0">
                        <div class="md-layout">
                          <div class="md-layout-item md-size-100 p-0">
                            <md-card class="m-0">
                              <md-card-header>Efficiency</md-card-header>
                              <md-card-content>
                                <div class="md-layout">
                                  <div class="md-layout-item md-medium-size-100 md-size-100 p-0">
                                    <md-table
                                      v-model="efficiency"
                                      table-header-color="blue"
                                      class="profit-and-loss-table"
                                    >
                                      <md-table-row
                                        slot="md-table-row"
                                        slot-scope="{ item }"
                                      >
                                        <md-table-cell md-label="Parameters" class="md-table-side-label">
                                          {{ item.name }}
                                          <!-- {{ tablesInfo[item.name]['title'] }} -->
                                          <!-- <md-tooltip md-direction="bottom" -->
                                          <!-- >{{ tablesInfo[item.name]['rollover'] }} -->
                                          <!-- </md-tooltip> -->
                                        </md-table-cell>

                                        <md-table-cell md-label="Trend" class="table_chart">
                                          <chart-card
                                            header-animation="false"
                                            :chart-data="colouredLineChart.data"
                                            :chart-options="colouredLineChart.options"
                                            chart-type="Line"
                                            header-icon
                                            chart-inside-content
                                            no-footer
                                            background-color="blue"
                                          >
                                          </chart-card>
                                        </md-table-cell>

                                        <md-table-cell
                                          v-for="key in Object.keys(item.dates)"
                                          :key="key"
                                          :md-label="key"
                                          >{{ item.dates[key] }}
                                        </md-table-cell>
                                      </md-table-row>
                                    </md-table>
                                  </div>
                                </div>
                              </md-card-content>
                            </md-card>
                          </div>

                          <div
                            v-for="(chart, index) in chartData.efficiency"
                            :key="index"
                            class="md-layout-item md-medium-size-100 md-size-50"
                          >
                            <chart-card
                              header-animation="false"
                              :chart-data="chart.data"
                              :chart-options="options"
                              chart-type="Line"
                              header-icon
                              chart-inside-content
                              no-footer
                              background-color="blue"
                            >
                              <template slot="chartInsideHeader">
                                <div class="card-icon">
                                  <md-icon>timeline</md-icon>
                                </div>
                                <h4 class="title">{{ chart.title }}</h4>
                              </template>
                            </chart-card>
                          </div>
                        </div>
                      </md-tab>
                      <!-- <md-tab md-label="Debt-Risk" md-icon="report" class="p-0">
                        <div class="md-layout">
                          <div class="md-layout-item md-size-100 p-0">
                            <md-card class="m-0">
                              <md-card-header>Debt-Risk</md-card-header>
                              <md-card-content>
                                <div class="md-layout">
                                  <div
                                    class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0"
                                  >
                                    <md-table
                                      v-model="turnover"
                                      table-header-color="blue"
                                      class="profit-and-loss-table"
                                    >
                                      <md-table-row
                                        slot="md-table-row"
                                        slot-scope="{ item }"
                                      >
                                        <md-table-cell class="md-table-side-label">
                                        </md-table-cell>
                                        <md-table-cell
                                          v-for="key in Object.keys(item.dates)"
                                          :key="key"
                                          :md-label="key"
                                          >{{ item.dates[key] }}
                                        </md-table-cell>
                                      </md-table-row>
                                    </md-table>
                                  </div>
                                </div>
                              </md-card-content>
                            </md-card>
                          </div>

                          <div
                            v-for="(chart, index) in chartData.turnover"
                            :key="index"
                            class="md-layout-item md-medium-size-100 md-size-50"
                          >
                            <chart-card
                              header-animation="false"
                              :chart-data="chart.data"
                              :chart-options="options"
                              chart-type="Line"
                              header-icon
                              chart-inside-content
                              no-footer
                              background-color="blue"
                            >
                              <template slot="chartInsideHeader">
                                <div class="card-icon">
                                  <md-icon>timeline</md-icon>
                                </div>
                                <h4 class="title">{{ chart.title }}</h4>
                              </template>
                            </chart-card>
                          </div>
                        </div>
                      </md-tab> -->
                    </md-tabs>
                  </template>
                </nav-tabs-card>
              </div>
            </div>
            <div class="extra_info_area neg_topMargin">
              <!--<md-card>
                <md-card-header><md-icon>account_balance</md-icon>Curabitur Eleifend</md-card-header>
                <md-card-content>
                  <h4>Praesent venenatis</h4>
                  <p>Sed et placerat lorem. Integer nec accumsan tortor. Nullam at eleifend urna. Donec pulvinar quam ligula, id tincidunt orci rutrum ut.</p>
                  <h4>Quisque ut ex ligula</h4>
                  <p>Nullam vel pulvinar nisl. Morbi aliquam scelerisque congue. Quisque ut ex ligula. Nunc eu nunc in nulla pulvinar efficitur non id leo. Praesent eget sem eget eros mattis malesuada.</p>
                </md-card-content>
              </md-card>-->
              <!-- <md-card>
                <md-card-header><md-icon>vertical_split</md-icon>Vivamus Hendrerit</md-card-header>
                <md-card-content>
                  <h4>Fusce feugiat mollis</h4>
                  <p>Sed et placerat lorem. Integer nec accumsan tortor. Nullam at eleifend urna. Donec pulvinar quam ligula, id tincidunt orci rutrum ut.</p>
                  <h4>Praesent eget sem eget</h4>
                  <p>Nullam vel pulvinar nisl. Morbi aliquam scelerisque congue. Quisque ut ex ligula. Nunc eu nunc in nulla pulvinar efficitur non id leo. Praesent eget sem eget eros mattis malesuada.</p>
                </md-card-content>
              </md-card> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { NavTabsCard, ChartCard } from '@/components';
import { mapState } from 'vuex';
import formatData from '@/mixins/format-data';
import SPIFProfileHeader from './_partials/SPIFProfileHeader.vue';

export default {
  components: {
    ChartCard,
    NavTabsCard,
    SPIFProfileHeader,
  },
  mixins: [formatData],
  props: ['headerData'],
  data() {
    return {
      view: 'cash-flow-solvency',
      options: {
        lineSmooth: this.$Chartist.Interpolation.cardinal({
          tension: 10,
        }),
        axisY: {
          showGrid: true,
          offset: 40,
        },
        axisX: {
          showGrid: false,
        },
        low: 0,
        showPoint: true,
        height: '300px',
      },
      colouredLineChart: {
        data: {
          labels: [1, 2, 3, 4, 5],
          series: [
            [1, 5, 3, 4, 2]
          ]
        },
        options: {
          lineSmooth: this.$Chartist.Interpolation.cardinal({
            tension: 1,
          }),
          chartPadding: {
            top: 5,
            right: 5,
            bottom: 5,
            left: 5
          },
          axisY: {
            showGrid: false,
            showLabel: false,
            offset: 0,
          },
          axisX: {
            showGrid: false,
            showLabel: false,
            offset: 0,
            scaleMinSpace: 6
          },
          showPoint: true,
          showLabel: false,
          width: "100px",
          height: "25px",
          seriesBarDistance: 10,
          fullWidth: true,
        },
      },
      filtered_years: [],
      filtered_firms: [],
      filtered_PLDollar: [],
      filtered_PLPercent: [],
      filtered_BSDollar: [],
      filtered_BSPercent: [],
      cashflow: [],
      cashFlowFilteredData: [],
      efficiency: [],
      efficiencyFilteredData: [],
      profitability: [],
      profitabilityFilteredData: [],
      turnover: [],
      debtRiskFilteredData: [],
      changein: [],
      changeinFilteredData: [],
      worksheet: [],
      worksheetFilteredData: [],
      chartData: {},
      showDialog: false,
      sales_class_csv: '',
    };
  },
  computed: {
    ...mapState({
      data: (state) => state.user.profile.data,
      profile: (state) => state.user.profile,
      PLtable: (state) => state.user.profile.data.tables['PL'],
      BStable: (state) => state.user.profile.data.tables['BS'],
      charts: (state) => state.user.profile.data.chartData['ratios'],
      tables: (state) => state.user.profile.data.tables['ratios'],
      tablesInfo: (state) => state.user.profile.data.tables['ratioInfo'],
      sourcesUses: (state) => state.user.profile.data['sourcesUses'],
      sourceYears: (state) => state.user.profile.data['sourcesUses']['years'],
      release_display: (state) => state.user.profile.release_display,
      bznaics_code: (state) => state.user.profile.bznaics,
      sector_name: (state) =>
        state.user.profile.data.data.data[0].sector
          ? state.user.profile.data.data.data[0].sector
          : '',
      industry_title: (state) =>
        state.user.profile.data.data.data[0].industry
          ? state.user.profile.data.data.data[0].industry
          : '',
      sales_class: (state) =>
        state.user.profile.data.data.data[0].sales_class
          ? state.user.profile.data.data.data[0].sales_class
          : '',
      display_area: (state) => {
        return state.user.profile.data.data.data[0].display_area
          ? state.user.profile.data.data.data[0].display_area
          : '';
      },
    }),
    sourceTablesInfo() {
      return _.omit(this.sourcesUses, 'years');
    },
    filteredProfile() {
      return Object.values(this.profile.data).filter((item) => item);
    },
    getCsvData() {
      let csvData = [
        ['Industry Financial Report'],
        ['"Release Date"', this.release_display],
        [''],
        ['Segment', 'Industry'],
        [this.industry_title],
        ['[' + parseInt(this.bznaics_code) + ']' + ' Sector', this.sector_name],
        ['Market', this.display_area],
        ['Sales Class', this.sales_class_csv],
        [''],
      ];
      csvData.push(['Firms Analyzed', this.filtered_years]);
      csvData.push(['', this.filtered_firms]);
      csvData.push(['']);
      csvData.push(['Income and Expense - Profit and Loss($)']);
      csvData.push(['', this.filtered_years]);
      this.filtered_PLDollar.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['Income and Expense - Profit and Loss(%)']);
      csvData.push(['', this.filtered_years]);
      this.filtered_PLPercent.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['Balance Sheet($)']);
      csvData.push(['Assets', this.filtered_years]);
      this.filtered_BSDollar.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['Balance Sheet(%)']);
      csvData.push(['Assets', this.filtered_years]);
      this.filtered_BSPercent.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['Financial Ratios: Cash Flow-Solvency']);
      csvData.push(['', this.filtered_years]);
      this.cashFlowFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['Financial Ratios: Profitability']);
      csvData.push(['', this.filtered_years]);
      this.profitabilityFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['Financial Ratios: Efficiency']);
      csvData.push(['', this.filtered_years]);
      this.efficiencyFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['Financial Ratios: Debt-Risk']);
      csvData.push(['', this.filtered_years]);
      this.debtRiskFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['Sources & Uses of Funds']);
      csvData.push(['', this.sourceYears]);
      this.changeinFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['Worksheet:']);
      this.worksheetFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      return csvData;
    },
    filteredData() {
      return Object.values(this.data).filter((item) => item);
    },
    actualData() {
      return this.filteredData[0]['cashflow'];
    },
  },
  mounted() {
    let section = this.$route.query.section;

    if (!section) {
      section = 'cash-flow-solvency';
    }

    this.switchView(section);
    this.data.years.forEach((e, i) => {
      this.filtered_years.push(Number(e));
    });
    let firmData = Object.values(this.data.data)
      .filter((item) => item)
      .map((item) => ({ ...item, firms: item.firms }));

    firmData.forEach((element) => {
      this.filtered_firms.push(parseFloat(element.firms));
    });
    if (this.sales_class.includes(',')) {
      this.sales_class_csv = this.sales_class.replace(/,/g, '');
    }
    let PLdollar = this.formatTable(this.PLtable, 'industry', 'dollar');
    let PLpercent = this.formatTable(this.PLtable, 'industry', 'percent');

    PLdollar.forEach((element) => {
      if (element.name.includes(',')) {
        element.name = element.name.replace(/,/g, '');
      }
      let k = Object.values(element.dates);
      let v = [];
      k.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = parseFloat(e.replace(/,/g, ''));
        }
        v.push(e);
      });
      v.unshift(element.name);
      this.filtered_PLDollar.push(v);
    });
    PLpercent.forEach((element) => {
      if (element.name.includes(',')) {
        element.name = element.name.replace(/,/g, '');
      }
      let z = Object.values(element.dates);
      let v = [];
      z.forEach((item, i) => {
        if (typeof item === 'string' && item.includes(',')) {
          item = parseFloat(item.replace(/,/g, ''));
        }
        v.push(item);
      });
      v.unshift(element.name);
      this.filtered_PLPercent.push(v);
    });

    let BSdollar = this.formatTable(this.BStable, 'industry', 'dollar');
    let BSpercent = this.formatTable(this.BStable, 'industry', 'percent');

    BSdollar.forEach((element) => {
      let k = Object.values(element.dates);
      let v = [];
      k.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = parseFloat(e.replace(/,/g, ''));
        }
        v.push(e);
      });

      v.unshift(element.name);
      this.filtered_BSDollar.push(v);
    });
    BSpercent.forEach((element) => {
      let z = Object.values(element.dates);
      let v = [];
      z.forEach((item, i) => {
        if (typeof item === 'string' && item.includes(',')) {
          item = parseFloat(item.replace(/,/g, ''));
        }
        v.push(item);
      });
      v.unshift(element.name);
      this.filtered_BSPercent.push(v);
    });

    if (!_.isEmpty(this.tables)) {
      Object.entries(this.tables).forEach(
        ([table, data]) => this.$set(this, table, this.formatTable(data, 'industry'))
      );
    }

    let cashFlowData = [];
    this.cashflow.forEach((element, index) => {
      if (element.name in this.tables.cashflow) {
        cashFlowData.push({
          dates: element.dates,
          title: element.name,
        });
      }
    });
    cashFlowData.forEach((element) => {
      let k = Object.values(element.dates);
      let v = [];
      k.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = parseFloat(e.replace(/,/g, ''));
        }
        v.push(e);
      });

      v.unshift(element.title);
      this.cashFlowFilteredData.push(v);
    });

    let efficiencyData = [];
    this.efficiency.forEach((element, index) => {
      if (element.name in this.tables['efficiency']) {
        efficiencyData.push({
          dates: element.dates,
          title: element.name,
        });
      }
    });
    efficiencyData.forEach((element) => {
      let k = Object.values(element.dates);
      let v = [];
      k.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = parseFloat(e.replace(/,/g, ''));
        }
        v.push(e);
      });

      v.unshift(element.title);
      this.efficiencyFilteredData.push(v);
    });

    let profitabilityData = [];
    this.profitability.forEach((element, index) => {
      if (element.name in this.tables['profitability']) {
        profitabilityData.push({
          dates: element.dates,
          title: element.name,
        });
      }
    });
    profitabilityData.forEach((element) => {
      let k = Object.values(element.dates);
      let v = [];
      k.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = parseFloat(e.replace(/,/g, ''));
        }
        v.push(e);
      });

      v.unshift(element.title);
      this.profitabilityFilteredData.push(v);
    });

    // let debtRiskData = [];
    // this.turnover.forEach((element, index) => {
    //   if (element.name in this.tables['turnover']) {
    //     debtRiskData.push({
    //       dates: element.dates,
    //       title: element.name,
    //     });
    //   }
    // });
    // debtRiskData.forEach((element) => {
    //   let k = Object.values(element.dates);
    //   let v = [];
    //   k.forEach((e, i) => {
    //      if (typeof e === 'string' && e.includes(',')) {
    //       e = parseFloat(e.replace(/,/g, ''));
    //     }
    //     v.push(e);
    //   });

    //   v.unshift(element.title);
    //   this.debtRiskFilteredData.push(v);
    // });

    Object.entries(this.sourceTablesInfo).forEach(([table, data]) =>
      this.$set(this, table, this.formatSourcesData(table, data))
    );

    this.changein.forEach((element, index) => {
      let k = [];
      Object.values(element.dates).forEach((e, index) => {
        k.push(e);
      });
      k.unshift(element.title);
      this.changeinFilteredData.push(k);
    });
    this.worksheet.forEach((element, index) => {
      let k = [];
      Object.values(element.dates).forEach((e, index) => {
        k.push(e);
      });
      k.unshift(element.title);
      this.worksheetFilteredData.push(k);
    });
  },
  watch: {
    '$route.query.section'() {
      let section = this.$route.query.section;

      if (!section) {
        section = 'cash-flow-solvency';
      }

      this.switchView(section);
    },
  },
  methods: {
    switchView: function(type) {
      this.view = type;
    },
    downloadCSVData() {
      let csv = '';
      this.getCsvData.forEach((row) => {
        csv += row.join(',');
        csv += '\n';
      });
      const anchor = document.createElement('a');
      anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
      anchor.target = '_blank';
      anchor.download = 'Industry Financial Profile.csv';
      anchor.click();
    },
    formatSourcesData(table, data) {
      let getDates = (id) =>
        this.sourceYears.reduce((acc, cur, index) => {
          let value = this.actualData[this.sourceYears.length - index - 1][id];

          value = isNaN(Number(value)) ? value : Number(value.toFixed(0));

          return { ...acc, [cur]: value };
        }, {});

      return data.map((item) => ({
        ...item,
        dates: getDates(item.id),
      }));
    },
  },
};
</script>
<style lang="scss">
.introduction-body {
  display: flex;
  align-items: flex-start;
}

.introduction-title {
  display: flex;
  flex-direction: column;
  justify-content: end;
}

.finanical-report-messages {
  width: 100%;
  display: flex !important;
  justify-content: space-between !important;
}

.messages-box {
  border-radius: 3px;
  background-color: #cccccc;
  padding: 1px !important;

  .md-icon {
    font-size: 1.1rem !important;
    color: #78909c !important;
  }
}
</style>
